import CommonIcon from "./CommonIcon";

const AddFieldIcon = () => {
  return (
    <CommonIcon>
      <path d="M560-280H120v-400h720v120h-80v-40H200v240h360v80Zm-360-80v-240 240Zm560 200v-120H640v-80h120v-120h80v120h120v80H840v120h-80Z" />
    </CommonIcon>
  );
};

export default AddFieldIcon;
